import * as yup from "yup";
import type { Section } from "../store/formBuilderStore";
import {
	FORM_DESCRIPTION_MAX_LENGTH,
	FORM_NAME_MAX_LENGTH,
	SECTION_DESCRIPTION_MAX_LENGTH,
	SECTION_TITLE_MAX_LENGTH,
} from "../types/template";

export const sectionSchema = yup.object({
	title: yup
		.string()
		.trim()
		.required("O nome da seção é obrigatório")
		.min(1, "O nome da seção não pode estar vazio")
		.max(
			SECTION_TITLE_MAX_LENGTH,
			`O nome da seção deve ter no máximo ${SECTION_TITLE_MAX_LENGTH} caracteres`
		)
		.test("unique", "Já existe uma seção com esse nome", function (value) {
			const context = this.options.context as
				| { sections?: Section[] }
				| undefined;
			const sections = context?.sections || [];
			const currentSection = this.parent as Section;
			return !sections.some(
				(s) => s !== currentSection && s.title.trim() === value?.trim()
			);
		}),
	description: yup
		.string()
		.trim()
		.max(
			SECTION_DESCRIPTION_MAX_LENGTH,
			`A descrição da seção deve ter no máximo ${SECTION_DESCRIPTION_MAX_LENGTH} caracteres`
		)
		.nullable(),
});

export const formSchema = yup.object({
	formName: yup
		.string()
		.trim()
		.required("O nome do formulário é obrigatório")
		.max(
			FORM_NAME_MAX_LENGTH,
			`O nome do formulário deve ter no máximo ${FORM_NAME_MAX_LENGTH} caracteres`
		),
	formDescription: yup
		.string()
		.trim()
		.max(
			FORM_DESCRIPTION_MAX_LENGTH,
			`A descrição do formulário deve ter no máximo ${FORM_DESCRIPTION_MAX_LENGTH} caracteres`
		)
		.nullable(),
	sections: yup
		.array()
		.of(sectionSchema)
		.min(1, "Adicione pelo menos uma seção")
		.test(
			"all-sections-named",
			"Preencha o nome de todas as seções",
			(sections) =>
				Boolean(sections?.every((section) => section.title?.trim().length))
		)
		.required("Adicione pelo menos uma seção"),
});
